import React from 'react';
import cls from '@utils/css-select';

import styles from './styles.scss';
import Section from 'components/section';
import { useSelector } from 'react-redux';
import { ConnectState } from 'states/connect';
import { USER_COUNTRY_CONIFG } from './const';
const cx = cls(styles);

/**
 *	学生评价模块
 * @returns
 */
export default function AppraisalBox() {
	const local = useSelector((state: ConnectState) => state.app.local);
	const users = USER_COUNTRY_CONIFG[local] || USER_COUNTRY_CONIFG['en-US'];
	return (
		<div className={cx('appraisal-block')} id="form-next">
			<Section>
				<h3 className={cx('block-title')}>91% of students have improved their grades!</h3>
				<div className={cx('star-comment')}>
					<div className={cx('star-num')}>
						<div className={cx('stars')}>
							<img
								loading="lazy"
								className={cx('star')}
								src="https://web-data.zmlearn.com/image/nX6uLPuHuVcB6kKoXdMgE/star%402x.png"
								alt="star"
							/>
							<img
								loading="lazy"
								className={cx('star')}
								src="https://web-data.zmlearn.com/image/nX6uLPuHuVcB6kKoXdMgE/star%402x.png"
								alt="star"
							/>
							<img
								loading="lazy"
								className={cx('star')}
								src="https://web-data.zmlearn.com/image/nX6uLPuHuVcB6kKoXdMgE/star%402x.png"
								alt="star"
							/>
							<img
								loading="lazy"
								className={cx('star')}
								src="https://web-data.zmlearn.com/image/nX6uLPuHuVcB6kKoXdMgE/star%402x.png"
								alt="star"
							/>
							<img
								loading="lazy"
								className={cx('star')}
								src="https://web-data.zmlearn.com/image/nX6uLPuHuVcB6kKoXdMgE/star%402x.png"
								alt="star"
							/>
						</div>
						<span>
							<b>4.9</b>/5
						</span>
					</div>
					<div className={cx('comment-num')}>999+ comments</div>
				</div>
				<div className={cx('appraisal-list', 'scroll-view')}>
					{users.map((item, idx) => {
						return (
							<div className={cx('appraisal-item')} key={idx}>
								<header className={cx('item-hd')}>
									<div className={cx('user')}>
										<img loading="lazy" src={item.avatr} alt={item.name} />
										<span>{item.name}</span>
									</div>
									<span className={cx('time')}>{item.date}</span>
								</header>
								<div className={cx('stars')}>
									<img
										loading="lazy"
										className={cx('star')}
										src="https://web-data.zmlearn.com/image/nX6uLPuHuVcB6kKoXdMgE/star%402x.png"
										alt="star"
									/>
									<img
										loading="lazy"
										className={cx('star')}
										src="https://web-data.zmlearn.com/image/nX6uLPuHuVcB6kKoXdMgE/star%402x.png"
										alt="star"
									/>
									<img
										loading="lazy"
										className={cx('star')}
										src="https://web-data.zmlearn.com/image/nX6uLPuHuVcB6kKoXdMgE/star%402x.png"
										alt="star"
									/>
									<img
										loading="lazy"
										className={cx('star')}
										src="https://web-data.zmlearn.com/image/nX6uLPuHuVcB6kKoXdMgE/star%402x.png"
										alt="star"
									/>
									<img
										loading="lazy"
										className={cx('star')}
										src="https://web-data.zmlearn.com/image/nX6uLPuHuVcB6kKoXdMgE/star%402x.png"
										alt="star"
									/>
								</div>
								<div className={cx('content')}>{item.text}</div>
							</div>
						);
					})}
				</div>
			</Section>
		</div>
	);
}
